<div class="card-shadow container mt-4">
    <h3>Edit Product</h3>
    <br>
    <div class="card-shadow container-fluid">
        <h6 class="text"><b>{{product.productTitle}}</b></h6>
        <hr />
        <div class="row mt-1">
            <div class="col-12 col-sm-12 col-lg-4">
                <img class="rounded" src={{product.image}} width=100% height=170px>
            </div>
            <div class="col-12 col-sm-12 col-lg-8">
                <div class="row">
                    <div class="col-12 col-sm-12 col-lg-12">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12">
                                <div class="btn btn-primary p-3 w-100 m-1">
                                    {{ [product.startsAt, product.endsAt] | bidStatus }}
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-12">
                                <div class="btn btn-primary p-3 w-100 m-1">
                                    <img src="https://img.icons8.com/fluent-systems-filled/24/ffffff/rupee.png"
                                        style="height: 20px; width: 20px;" /> {{product.auctionAmount}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr/>
    <div class="form-group p-1">
        <button class="btn btn-success float-right " (click)="update()">Update</button>
    </div>
    <div class="form-group ">
        <label for="productTitle"><b>Title</b></label>
        <input [(ngModel)]="product.productTitle" type="text" class="form-control" id="productTitle">
    </div>
    <div class="form-group">
        <label for="productDescription"><b>Description</b></label>
        <textarea type="text" class="form-control" id="productDescription"
            [(ngModel)]="product.productDescription"></textarea>
    </div>
    <div class="container" style="height: 150px; width: 100%;">
        <div class="row h-100 w-100 img-scroll">
            <div class="img-card col-12 col-sm-8 col-md-6 col-xl-4 "
                *ngFor="let image of product.productImages; let i = index">
                <div class="card h-100 w-100 p-0" style="position: relative; overflow: hidden; cursor: pointer;">
                    <img class="img-fluid h-100 w-100 p-0" src={{image.url}} />
                    <img (click)="removeImage(i)" src="https://img.icons8.com/ios-glyphs/30/ffffff/macos-close.png"
                        style="position: absolute; top: 5px; right: 5px; width: 25px; height: 25px;" />
                </div>
            </div>
            <div class="img-card col-8 col-sm-8 col-md-6 col-xl-4 ">
                <button class="btn btn-primary h-100 w-100" (click)="fileInput.click()">
                    <input #fileInput type="file" accept="image/*" (change)="addImage($event)" style="display:none;" />
                    <span>
                        <img src="https://img.icons8.com/android/24/ffffff/plus.png" style="margin: 10px;" />
                        Add {{ 5 - product.productImages.length}} Images
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-12 col-sm-6 col-lg-6">
            <label for="manufacturedBy"><b>Manufactured by</b></label>
            <input [(ngModel)]="product.manufacturer" type="text" class="form-control" id="manufacturedBy"
                placeholder="">
        </div>
        <div class="col-12 col-sm-6 col-lg-6" *ngIf="product.price">
            <label class="block" for="flipkartPrice">Flipkart Price<a style="cursor: pointer; margin-left: 20px;"
                    (click)="removePrice()"><img
                        src="https://img.icons8.com/material-rounded/24/fa314a/filled-trash.png" /></a></label>

            <span class="border rounded border-success " id="flipkartPrice"
                style="padding:5px 10px 5px 10px; display: block; ">{{product.price}}</span>
        </div>

    </div>
    <form [formGroup]="highlights_form">
        <div class="form-group  row">

            <div class="col-12 col-sm-12 col-lg-12"><label><b>Product Highlights</b></label></div>

            <div class="col-12 col-sm-10 col-lg-10">
                <input formControlName="highlight" type="text" class="form-control" required>
            </div>
            <div class="col-12 col-sm-2 col-lg-2">
                <button [disabled]="highlights_form.invalid" (click)="addHighlight()" type="submit"
                    class="btn float-left btn-primary m-2">Add</button>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-12 col-sm-12 col-lg-12">
            <div class=" my-style rounded"
                style="margin-top:10px; margin-right: 10px; display: inline-block; padding: 10px;"
                *ngFor=" let highlight of product.productHiglight; let i = index">

                <span class=" border  border-primary rounded text-primary card-body"
                    style="padding-top: 5px; padding-left:10px; padding-bottom:5px; padding-right: 10px; display: inline-block;"><b>{{highlight}}</b></span>

                <a style="cursor: pointer; margin-left: 20px; display:inline-block;" (click)="removeHighLight(i)"><img
                        src="https://img.icons8.com/material-rounded/24/fa314a/filled-trash.png" /></a>
            </div>
        </div>
    </div>
    <form [formGroup]="feature_form">
        <div class="form-group  row">
            <div class="col-12 col-sm-12 col-lg-12 p-3">
                <label for="exampleInputEmail1"><b>Add Features</b></label>
            </div>

            <div class="col-12 col-sm-10 col-lg-10 form-inline">
                <input formControlName="name" type="text" class="form-control" placeholder="Feature" required>
                <p class="p-2 m-2">:</p><input formControlName="value" type="text" class="form-control"
                    placeholder="Value" required>
            </div>

            <div class="col-12 col-sm-2 col-lg-2">
                <button [disabled]="feature_form.invalid" (click)="addFeature()" type="submit"
                    class="btn float-left btn-primary m-2">Add</button>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-12 col-sm-12 col-lg-12">
            <div class=" my-style rounded"
                style="margin-top:10px; margin-right: 10px; display: inline-block; padding: 10px;"
                *ngFor="let feature of product.productFeatures; let i = index">
                <span class=" border  border-primary rounded text-primary card-body"
                    style="padding-top: 5px; padding-left:10px; padding-bottom:5px; padding-right: 10px; display: inline-block;"><b>{{feature.name}}</b></span>
                :
                <input class=" text-success rounded border border-success" placeholder="enter value"
                    [(ngModel)]="feature.value"
                    style="padding-top: 5px; padding-left:10px; padding-bottom:5px; padding-right: 5px; display: inline-block;" />
                <a style="cursor: pointer; margin-left: 20px; display:inline-block;" (click)="removeFeature(i)"><img
                        src="https://img.icons8.com/material-rounded/24/fa314a/filled-trash.png" /></a>
            </div>
        </div>
    </div>
    <div class="row my-style">
        <div class="col-12 col-sm-12 col-lg-12">
            <div class="form-group">
                <label for="map"><b>Pick Up Point</b></label>
                <div class="map" id="map">
                </div>
            </div>
        </div>
    </div>
</div>